module.exports = __webpack_public_path__ + "img/high-fi-prototype-2.2362d70c.gif";